import { render, staticRenderFns } from "./Inscription-histoire.vue?vue&type=template&id=2af6a78a&scoped=true&"
import script from "./Inscription-histoire.vue?vue&type=script&lang=js&"
export * from "./Inscription-histoire.vue?vue&type=script&lang=js&"
import style0 from "./Inscription-histoire.vue?vue&type=style&index=0&id=2af6a78a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af6a78a",
  null
  
)

export default component.exports